import React from 'react';
import '../../styles/ContactPage/contact.css';
import { Phone, Mail, MapPin } from 'lucide-react';

function ContactMe() {
  return (
    <section id="contact" className="contact-cta">
      {/* Hero Image with Overlay (No Curve) */}
      <div className="hero-banner contact-banner">
        <div className="overlay"></div>
        <div className="hero-content">
          <h1>Contact Us</h1>
          <p>
            <span>Home</span> &nbsp;›&nbsp; <span className="active">Contact Us</span>
          </p>
        </div>
      </div>

      {/* Contact Form Section */}
      <div className="contact-main">
        <div className="contact-left">
          <img
            src={require('../../assets/contactimg.jpg')}
            alt="Side Graphic"
          />
        </div>
        <div className="contact-right">
          <h2 className="contact-heading">Get in Touch</h2>
          <form className="contact-form" onSubmit={(e) => e.preventDefault()}>
  <div className="form-row">
    <div className="form-group">
      <label htmlFor="name">Name:</label>
      <input
        type="text"
        id="name"
        name="name"
        placeholder="e.g., John Doe"
        required
      />
    </div>
    <div className="form-group">
      <label htmlFor="email">Email:</label>
      <input
        type="email"
        id="email"
        name="email"
        placeholder="e.g., john@example.com"
        required
      />
    </div>
  </div>

  <div className="form-group full-width">
    <label htmlFor="subject">Subject:</label>
    <input
      type="text"
      id="subject"
      name="subject"
      placeholder="e.g., Inquiry about services"
      required
    />
  </div>

  <div className="form-group full-width">
    <label htmlFor="message">Comment:</label>
    <textarea
      id="message"
      name="message"
      rows="6"
      placeholder="Write your message here..."
      required
    ></textarea>
  </div>

  <button type="submit">Submit</button>
</form>

        </div>
      </div>

      {/* Contact Info */}
      <div className="contact-info">
        <div className="info-item">
          <Phone size={36} />
          <h4>Phone</h4>
          <p>Start working with Techwiz that can<br /> provide everything</p>
          <a href="tel:+152534468854">+31 6 86073862</a>
        </div>
        <div className="info-item">
          <Mail size={36} />
          <h4>Email</h4>
          <p>Start working with Techwiz that can <br />provide everything</p>
          <a href="mailto:contact@example.com">info@vskglobalinfotech.com</a>
        </div>
        <div className="info-item">
          <MapPin size={36} />
          <h4>Location</h4>
          <p>C/54 Northwest Freeway, Poland,<br />Netherlands</p>
          <a href="https://maps.google.com" target="_blank" rel="noopener noreferrer">View on Google Maps</a>
        </div>
      </div>

      {/* Map */}
      <div className="map-view">
        <iframe
          title="Location Map"
          width="100%"
          height="500"
          frameBorder="0"
          style={{ border: 0 }}
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13859.299178768907!2d-95.45974990000001!3d29.741423649999998!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8640bf3b61b4f625%3A0x5431a6e6c6bca6ec!2sNorthwest%20Freeway%20%26%20Fairbanks%20North%20Houston%20Rd%2C%20Houston%2C%20TX%2077002%2C%20USA!5e0!3m2!1sen!2sin!4v1624498981067!5m2!1sen!2sin"
          allowFullScreen=""
        ></iframe>
      </div>
    </section>
  );
}

export default ContactMe;
